import { render, staticRenderFns } from "./Assurance.vue?vue&type=template&id=97207654"
import script from "./Assurance.vue?vue&type=script&lang=js"
export * from "./Assurance.vue?vue&type=script&lang=js"
import style0 from "./Assurance.vue?vue&type=style&index=0&id=97207654&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports